import { render, staticRenderFns } from "./TableViewSection.vue?vue&type=template&id=79b9d96d&scoped=true&"
import script from "./TableViewSection.vue?vue&type=script&lang=js&"
export * from "./TableViewSection.vue?vue&type=script&lang=js&"
import style0 from "./TableViewSection.vue?vue&type=style&index=0&id=79b9d96d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b9d96d",
  null
  
)

export default component.exports